<button class="w-100 btn btn-outline-info" (click)="addItem()" *ngIf="isTop; else forSubNodes">{{ 'TREE_COMP.ADD_BTN_CUSTOMER' | translate | uppercase }}</button>
<ng-template #forSubNodes>
    <div class="add_icon">
        <i class="material-icons pointer" title="{{ 'TREE_COMP.ADD_BTN_ORG' | translate }}" (click)="addItem()">add</i>
    </div>
</ng-template>